import { SearchQueryOrderDirection, StackState } from "types/generated";
import { AnalyticsPageStack } from "hooks/useAnalytics/pages/stack";
import { PAGINATION_OPTIONS } from "components/Table/Pagination/constants";

export const STACK_LIST_NEW_FEEDBACK_ID = "feedback-id-for-stack-list-new";

export const FILTER_TYPE = "stacks";

export const initialSortOption = "starred";
export const initialSortDirection = SearchQueryOrderDirection.Desc;

export const INITIAL_STACKS_LIMIT = 50;

export const FILTERS_ORDER_SETTINGS_KEY = "stacksFiltersOrder";

export enum PredefinedFilterType {
  AllStacks = "allStacks",
  NeedsAttention = "needsAttention",
  Failed = "failed",
  OnHold = "onHold",
  InProgress = "inProgress",
  Finished = "finished",
}

export const PREDEFINED_FILTER_STATES: Record<
  Exclude<PredefinedFilterType, PredefinedFilterType.AllStacks>,
  readonly StackState[]
> = {
  [PredefinedFilterType.NeedsAttention]: [StackState.Unconfirmed],
  [PredefinedFilterType.Failed]: [StackState.Failed],
  [PredefinedFilterType.OnHold]: [
    StackState.Confirmed,
    StackState.None,
    StackState.Ready,
    StackState.ReplanRequested,
  ],
  [PredefinedFilterType.InProgress]: [
    StackState.Applying,
    StackState.Destroying,
    StackState.Initializing,
    StackState.Planning,
    StackState.Preparing,
    StackState.PreparingApply,
    StackState.PreparingReplan,
  ],
  [PredefinedFilterType.Finished]: [StackState.Finished],
};

export const STACK_LIMIT_STORAGE_KEY = "stacksLimit";

export const STACK_PAGINATION_OPTIONS = [...PAGINATION_OPTIONS, 100];

enum STACKS_COLUMN_ID {
  FAVORITE = "FAVORITE",
  STATE = "STATE",
  NAME = "NAME",
  LABELS = "LABELS",
  SPACE = "SPACE",
  VENDOR = "VENDOR",
  BRANCH = "BRANCH",
  COMMIT = "COMMIT",
  GIT_TAG = "GIT_TAG",
  REPOSITORY = "REPOSITORY",
  PROJECT_ROOT = "PROJECT_ROOT",
  DELTA_COUNTS = "DELTA_COUNTS",
  UPDATED_AT = "UPDATED_AT",
  LAST_APPLY_ATTEMPT = "LAST_APPLY_ATTEMPT",
  DESCRIPTION = "DESCRIPTION",
  BLUEPRINT = "BLUEPRINT",
  DROPDOWN = "DROPDOWN",
  ISSUES = "ISSUES",
  SETTINGS = "SETTINGS",
}

export const SORT_CONFIG: Record<string, string> = {
  [STACKS_COLUMN_ID.NAME]: "name",
  [STACKS_COLUMN_ID.FAVORITE]: "starred",
  [STACKS_COLUMN_ID.STATE]: "state",
  [STACKS_COLUMN_ID.UPDATED_AT]: "stateSetAt",
  [STACKS_COLUMN_ID.LAST_APPLY_ATTEMPT]: "lastApplyAt",
  [STACKS_COLUMN_ID.BRANCH]: "branch",
  [STACKS_COLUMN_ID.REPOSITORY]: "repository",
  [STACKS_COLUMN_ID.SPACE]: "space",
  [STACKS_COLUMN_ID.PROJECT_ROOT]: "projectRoot",
  [STACKS_COLUMN_ID.GIT_TAG]: "tag",
};

export const ANALYTICS = {
  analyticsPage: AnalyticsPageStack.StacksList,
};
